import axios from "../helper/AxiosHelper";
import ApiHelper from "./ApiHelper";



const getTopSkillParticipantCount = async (orgType) => {

  // const data = {};
  const response = await axios.get(`/passport/getTopSkillParticipantCount?org_type=${orgType}`);

  return ApiHelper.processResponse(response);
};

// getTopMemberPlayTimeWithOrgSkill?org_id=145&skill_code=hoshun_karate
const getTopMemberPlayTimeWithOrgSkill = async (orgID, skillCode) => {

  const url = `/passport/getTopMemberPlayTimeWithOrgSkill?org_id=${orgID}&skill_code=${skillCode}`;
  const response = await axios.get(url);

  return ApiHelper.processResponse(response);
}



// getTopMemberPlayTimeWithOrgSkill?org_id=145&skill_code=hoshun_karate
const getTopMemberPlayTime = async (orgType) => {

  const orgID = 0;
  const skillCode = '';

  const url = `/passport/getTopMemberPlayTimeWithOrgSkill?org_id=${orgID}&skill_code=${skillCode}&org_type=${orgType}`;
  const response = await axios.get(url);

  return ApiHelper.processResponse(response);
}



const getTopOrgPlayTime = async (orgType) => {
  const response = await axios.get(`/passport/getTopOrgPlayTime?org_type=${orgType}`);

  return ApiHelper.processResponse(response);
}


const getTopSkillPlayer = async (skillCode, orgType) => {
  const params = new URLSearchParams({ skill_code: skillCode });
  if (orgType) params.append("org_type", orgType);

  const response = await axios.get(`/passport/getTopSkillPlayer?${params.toString()}`);

  return ApiHelper.processResponse(response);
}




export const LeaderboardApi = {
  getTopMemberPlayTime,
  getTopMemberPlayTimeWithOrgSkill,
  getTopOrgPlayTime,
  getTopSkillParticipantCount,
  getTopSkillPlayer,
};
